/* BKS - provenance du client dans les liens de reprise des configurateurs (04/10/2026, Arthur).
   Chargé uniquement sur les 3 configurateurs qui créent un lien de reprise, avant leur propre script :
   FUSION (templates/page.creer-ma-selle-fusion.liquid, lien ?s=), scooter (page.creer-ma-selle-scooter.liquid,
   lien ?c=) et selle custom (page.cree-ma-selle-custom.json, lien #cfg=). Ne modifie aucun de leurs scripts.
   1) Quand le client copie le lien de sa selle (« Copier le lien ») ou se l'envoie par e-mail (Klaviyo,
      formulaire de contact), on ajoute au lien la provenance de sa visite : utm_* et identifiant de clic
      Google / Meta / TikTok / Bing, lus dans l'adresse de la page ou, à défaut, dans les attributs du
      panier (écrits par wetracked dès la 1re page). Sans provenance connue : utm_source=lien_reprise.
      Résultat : un retour plus tard ou sur un autre appareil garde la source d'origine.
      Si la copie est bloquée par le navigateur, le lien affiché à la place est complété aussi.
   2) Quand le client revient par un lien de reprise (?s=, ?c= ou #cfg=), on note bks_reprise dans
      le panier : la commande le garde dans ses informations supplémentaires.
   Aucun cookie ni stockage sur l'appareil. En cas de souci, tout retombe sur le comportement d'origine. */
(function () {
  'use strict';
  if (window.BKS_SRC) return;

  var CLES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id',
              'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
  var src = null;
  var capture = null;

  function vide(o) {
    for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) return false; }
    return true;
  }

  function lireParams(search) {
    var o = {}, p;
    try { p = new URLSearchParams(search); } catch (e) { return o; }
    CLES.forEach(function (k) {
      var v = p.get(k);
      if (v) o[k] = String(v).slice(0, 250);
    });
    return o;
  }

  /* 1. la page elle-même : arrivée directe sur le configurateur depuis une pub */
  var ici = lireParams(location.search);
  if (!vide(ici)) src = ici;

  /* 2. sinon les attributs du panier (wetracked y range utm + identifiants de clic) */
  function chargerPanier() {
    try {
      window.fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          var a = (c && c.attributes) || {}, o = {};
          CLES.forEach(function (k) { if (a[k]) o[k] = String(a[k]).slice(0, 250); });
          if (!src && !vide(o)) src = o;
        })['catch'](function () {});
    } catch (e) {}
  }

  function estLienReprise(u) {
    return typeof u === 'string' &&
      u.indexOf(location.host) !== -1 &&
      (/\/pages\/cree-ta-selle[^?#\s]*\?(?:[^#\s]*&)?[sc]=/.test(u) ||
       /\/pages\/creer-ma-selle-custom[^#\s]*#cfg=/.test(u));
  }

  /* ajoute la provenance à la fin du lien, sans toucher à la config encodée dans ?s= / ?c= */
  function ajouterSource(u) {
    try {
      if (!estLienReprise(u)) return u;
      var o = src || {}, ajouts = [];
      function present(k) { return new RegExp('[?&]' + k + '=').test(u); }
      if (vide(o)) {
        if (!present('utm_source')) {
          ajouts.push('utm_source=lien_reprise', 'utm_medium=configurateur',
                      'utm_campaign=' + quelConfigurateur(u));
        }
      } else {
        CLES.forEach(function (k) {
          if (o[k] && !present(k)) ajouts.push(k + '=' + encodeURIComponent(o[k]));
        });
      }
      if (!ajouts.length) return u;
      var h = u.indexOf('#'), base = h === -1 ? u : u.slice(0, h), fin = h === -1 ? '' : u.slice(h);
      return base + (base.indexOf('?') === -1 ? '?' : '&') + ajouts.join('&') + fin;
    } catch (e) { return u; }
  }

  function quelConfigurateur(u) {
    return /creer-ma-selle-custom/.test(u) ? 'custom' : (/scooter/.test(u) ? 'scooter' : 'fusion');
  }

  function clicPub(o) {
    if (o.gclid || o.gbraid || o.wbraid) return 'google';
    if (o.fbclid) return 'meta';
    if (o.ttclid) return 'tiktok';
    if (o.msclkid) return 'bing';
    return 'aucun';
  }

  /* événement Klaviyo « Selle … sauvegardée » : liens complétés + provenance dans les propriétés */
  function corrigerKlaviyo(s) {
    try {
      var j = JSON.parse(s), at = j && j.data && j.data.attributes, p = at && at.properties;
      var nom = at && at.metric && at.metric.data && at.metric.data.attributes && at.metric.data.attributes.name;
      if (!p || typeof p !== 'object' || !/sauvegard/i.test(String(nom || ''))) return s;
      for (var k in p) {
        if (Object.prototype.hasOwnProperty.call(p, k) && /Lien/.test(k) && typeof p[k] === 'string') {
          p[k] = ajouterSource(p[k]);
        }
      }
      var o = src || {};
      if (vide(o)) {
        p.SourceVisite = 'inconnue';
      } else {
        var c = clicPub(o);
        p.SourceVisite = o.utm_source || (c !== 'aucun' ? c : 'inconnue');
        if (o.utm_medium) p.SupportVisite = o.utm_medium;
        if (o.utm_campaign) p.CampagneVisite = o.utm_campaign;
        p.ClicPub = c;
      }
      return JSON.stringify(j);
    } catch (e) { return s; }
  }

  function copier(init, modif) {
    var o = {}, k;
    for (k in init) { if (Object.prototype.hasOwnProperty.call(init, k)) o[k] = init[k]; }
    for (k in modif) { if (Object.prototype.hasOwnProperty.call(modif, k)) o[k] = modif[k]; }
    return o;
  }

  /* fetch : on ne touche qu'à l'événement Klaviyo et au formulaire de contact, le reste passe tel quel */
  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    var fetchBks = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (init && init.body) {
          if (/^https:\/\/a\.klaviyo\.com\/client\/events\//.test(url) && typeof init.body === 'string') {
            init = copier(init, { body: corrigerKlaviyo(init.body) });
          } else if (/^\/contact(?:[?#]|$)/.test(url) && typeof URLSearchParams !== 'undefined' &&
                     init.body instanceof URLSearchParams) {
            var b = init.body.get('contact[body]');
            if (b) init.body.set('contact[body]', b.replace(/https?:\/\/[^\s]+/g, ajouterSource));
          }
        }
      } catch (e) {}
      return fetchOrigine.call(window, input, init);
    };
    fetchBks.bks = true;
    window.fetch = fetchBks;
  }

  /* presse-papiers : « Copier le lien » des trois configurateurs */
  try {
    var cb = navigator.clipboard;
    if (cb && typeof cb.writeText === 'function') {
      var ecrireOrigine = cb.writeText;
      var ecrireBks = function (t) {
        if (capture) { capture(t); return Promise.resolve(); }
        return ecrireOrigine.call(cb, ajouterSource(t));
      };
      ecrireBks.bks = true;
      try { cb.writeText = ecrireBks; } catch (e) {}
      if (cb.writeText !== ecrireBks && window.Clipboard && Clipboard.prototype.writeText) {
        var protoOrigine = Clipboard.prototype.writeText;
        Clipboard.prototype.writeText = function (t) {
          if (capture) { capture(t); return Promise.resolve(); }
          return protoOrigine.call(this, ajouterSource(t));
        };
      }
    }
  } catch (e) {}

  /* presse-papiers bloqué (navigateurs intégrés d'Instagram, TikTok…) : le configurateur affiche alors
     le lien à copier à la main dans #lok (FUSION), #scok (scooter) ou #sc-saveok (selle custom) ;
     on y affiche la version complétée */
  function corrigerAffichage() {
    ['lok', 'scok', 'sc-saveok'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var t = (el.textContent || '').trim();
      if (t && estLienReprise(t)) {
        var n = ajouterSource(t);
        if (n !== t) el.textContent = n;
      }
    });
  }
  try {
    if (window.MutationObserver && document.documentElement) {
      new MutationObserver(corrigerAffichage).observe(document.documentElement,
        { childList: true, subtree: true, characterData: true });
    }
  } catch (e) {}

  /* selle custom, « Me l'envoyer par email » : le configurateur ouvre directement la messagerie avec le
     lien. On récupère ce lien via son bouton « Copier le lien » (sans toucher au presse-papiers), puis on
     ouvre la même messagerie avec le lien complété. Au moindre souci, le bouton d'origine fait son travail. */
  try {
    document.addEventListener('click', function (e) {
      var mail = e.target && e.target.closest && e.target.closest('#sc-savemail');
      var copie = document.getElementById('sc-savelink');
      if (!mail || !copie || typeof copie.onclick !== 'function') return;
      var lien = null, ok = document.getElementById('sc-saveok'), avant = ok ? ok.textContent : null;
      capture = function (t) { lien = t; };
      try { copie.onclick.call(copie); } catch (err) {}
      capture = null;
      if (typeof lien !== 'string' || !estLienReprise(lien)) {
        if (ok) ok.textContent = avant;
        return;
      }
      e.stopImmediatePropagation();
      e.preventDefault();
      setTimeout(function () { if (ok) ok.textContent = avant; }, 30);
      location.href = 'mailto:?subject=' + encodeURIComponent('Ma selle custom BKS — lien de reprise') +
        '&body=' + encodeURIComponent('Reprends ta configuration ici :\n\n' + ajouterSource(lien));
    }, true);
  } catch (e) {}

  /* retour par un lien de reprise : on le note dans le panier (après l'écriture de wetracked) */
  function noterReprise() {
    try {
      var p = new URLSearchParams(location.search);
      var custom = /creer-ma-selle-custom/.test(location.pathname) && location.hash.indexOf('#cfg=') === 0;
      if (!p.has('s') && !p.has('c') && !custom) return;
      var quoi = quelConfigurateur(location.pathname);
      setTimeout(function () {
        try {
          window.fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { bks_reprise: 'lien ' + quoi + ' ' + new Date().toISOString().slice(0, 10) } })
          })['catch'](function () {});
        } catch (e) {}
      }, 3000);
    } catch (e) {}
  }

  chargerPanier();
  noterReprise();

  window.BKS_SRC = {
    source: function () { return src; },
    ajouterSource: ajouterSource,
    corrigerKlaviyo: corrigerKlaviyo,
    essai: function (o) { src = o || null; }
  };
})();
